export default __webpack_public_path__ + "static/media/soundgraph-play.dc0e0b25.png";